// Override of core performPriceFilter (filtersHelpers.ts).
// Uses nightlyDiscountAwareTaxesAndFeesIncluded and priceWithAllDiscounts
// to match the displayed price on hotel cards.
import type { PriceRange } from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api";

export const performPriceFilter = (
  lodging: Lodging,
  hasSetPriceFilter: boolean,
  priceFilter: PriceRange
) => {
  if (!hasSetPriceFilter) return true;
  if (lodging.price == null) return false;

  const nightlyDA =
    lodging.price.nightlyDiscountAwareTaxesAndFeesIncluded ??
    lodging.price.nightlyDiscountAware;
  const price = (
    nightlyDA.priceWithAllDiscounts ?? nightlyDA.priceWithUnmanagedDiscounts
  ).fiat.value;

  return priceFilter.min <= price && priceFilter.max >= price;
};
